<template>
  <!-- 喵咪商品制作工艺 -->
  <div
    id="manufacturing"
    v-if="this.ppadmin_data && ppadmin_data[5].data.length != []"
  >
    <div class="as">
      <div class="mb">
        <p class="text-align" v-html="content1"></p>
      </div>
      <div class="wrapper">
        <div
          v-for="(item, index) in imgs"
          :key="index"
          class="wow slideInFromLeft"
          :class="'box' + (index + 1)"
          :data-wow-duration="(index + 1) * 0.5 + 's'"
        >
          <img
            loading="lazy"
            :style="`background-image: url('${item.images}');`"
            :alt="item.title"
          />
          <div class="contents">
            <div class="title">
              <h2>{{ item.title }}</h2>
            </div>
            <div class="detail text-align">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="pc">
        <p class="text-align" v-html="content1"></p>
      </div>
      <div class="content text-align" v-if="video1.title != null">
        <b></b>
        <span class="title-main">{{ video1.title }}</span>
        <b></b>
      </div>
      <template v-if="video1.title != null">
        <div class="row" v-for="(itme, indx) in 2" :key="indx">
          <section v-for="(item, index) in 2" :key="index">
            <h3>
              <strong>{{ video1.items[indx + index].title }}</strong>
            </h3>
            <p v-html="video1.items[indx + index].content"></p>
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                :src="video1.items[indx + index].video"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </section>
        </div>
      </template>

      <div class="content text-align" v-if="video2.title != null">
        <b></b>
        <span class="title-main">{{ video2.title }}</span>
        <b></b>
      </div>
      <template v-if="video2.title != null">
        <div class="row">
          <section style="width: 100%">
            <p class="text-align" v-html="video2.content"></p>
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                :src="video2.video"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
            <!-- <iframe style="width: 100%;" src="https://www.youtube.com/embed/dUl6aKIs46g"
          frameborder="0"></iframe> -->
          </section>
        </div>
      </template>
      <div class="content text-align">
        <b></b>
        <span class="title-main">{{ content2.title }}</span>
        <b></b>
      </div>
      <div class="row">
        <section style="width: 100%" v-html="content2.content"></section>
      </div>
      <div class="content text-align">
        <b></b>
        <span class="title-main">{{ QandA.title }}</span>
        <b></b>
      </div>
      <div class="row">
        <section style="width: 100%; padding: 1em 0">
          <el-collapse accordion>
            <el-collapse-item v-for="(item, index) in QandA.items" :key="index">
              <template slot="title">
                {{ index + 1 + "、" + item.title }}
              </template>
              <div v-html="item.content"></div>
            </el-collapse-item>
          </el-collapse>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import WOW from "wowjs";
export default {
  name: "ManufacturingView",
  data() {
    return {};
  },
  computed: {
    ...mapState("headerNav", ["ppadmin_data"]),
    imgs() {
      return this.ppadmin_data[5].data.imgs;
    },
    content1() {
      return this.ppadmin_data[5].data.content1;
    },
    video1() {
      return this.ppadmin_data[5].data.video1;
    },
    video2() {
      return this.ppadmin_data[5].data.video2;
    },
    content2() {
      return this.ppadmin_data[5].data.content2;
    },
    QandA() {
      return this.ppadmin_data[5].data.QandA;
    },
  },
  mounted() {
    // new WOW.WOW({
    //   live: false, // 设置为false以确保只对初始内容进行动画处理
    // }).init();
    if (typeof window !== "undefined") {
      const WOW = require("wowjs");
      new WOW.WOW({
        live: false, // 设置为false以确保只对初始内容进行动画处理
      }).init();
    }
  },
};
</script>

<style lang="less" scoped>
#manufacturing {
  ::v-deep .el-collapse {
    .el-collapse-item__header {
      white-space: normal;
      line-height: 2;
      padding: 1em;
      height: auto;
      width: 100%;
      box-sizing: border-content;
      overflow: hidden;
    }
    .el-collapse-item__content {
      padding: 0.5em 1em;
    }
  }
  .mobile({
    padding: 0 1em
  });
  .as {
    max-width: 1050px;
    margin: auto;
    font-size: 16px;
    letter-spacing: 0.2em;
    text-align: left;
    font-family: @font-family-regular;

    .mb {
      display: none;
    }

    .pc {
      padding: 0 0 30px;
      display: block;
    }

    // display: flex;
    .slideInFromLeft {
      position: relative;

      img {
        overflow: hidden;
        // background-position: 32% 58%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        transition: background-size 0.3s ease-in-out;

        &:hover {
          background-size: 110% 110%;
        }
      }

      .contents {
        color: white;
        transform: translate(-50%, -50%);
        width: 60%;
        position: absolute;
        top: 50%;
        left: 50%;
      }
    }

    .content {
      padding: 1.5em 0;
      position: relative;
      -js-display: flex;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      width: 100%;

      b {
        display: block;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        height: 2px;
        opacity: 0.1;
        background-color: currentColor;
      }
    }

    .row {
      max-width: 1050px;
      display: flex;

      margin-left: auto;
      // justify-content: space-between;

      section {
        padding: 0 15px;
        padding-bottom: 30px;
        width: 48%;
      }
    }
  }

  h3 {
    font-size: 16px;
  }

  .title-main {
    border: 2px solid rgba(0, 0, 0, 0.1);
    padding: 6px 16px;
  }

  .text-align {
    text-align: center;
  }

  @keyframes slideInFromLeft {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .slideInFromLeft {
    animation-name: slideInFromLeft;
  }

  .wrapper {
    padding: 0 0 30px;
    margin: auto;
    max-width: 1042.5px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 1em;

    div {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .box1 {
    height: 313px;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }

  .box2 {
    height: 424px;
    grid-column-start: 3;
    grid-row-start: 1;
    grid-row-end: 4;
  }

  .box3 {
    height: 313px;
    grid-column-start: 1;
    grid-row-start: 3;
    grid-row-end: 6;
  }

  .box4 {
    height: 313px;
    grid-column-start: 2;
    grid-row-start: 3;
    grid-row-end: 6;
  }

  .box5 {
    height: 202px;
    grid-column-start: 3;
    grid-row-start: 4;
    grid-row-end: 6;
  }

  @media only screen and (max-width: 992px) {
    .as {
      .mb {
        display: block;
      }

      .pc {
        display: none;
      }
      .row {
        flex-wrap: wrap;
        section {
          width: 100%;
        }
      }
      // background-color: red;
    }

    .wrapper {
      display: block;
      .slideInFromLeft {
        padding-bottom: 20px;
      }
    }

    .box1 {
      height: 202px;
    }

    .box2 {
      display: none;
    }
  }
}
</style>
